// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 7210) return "static/chunks/7210.034db78389a3ec36.js";
	if (chunkId === 593) return "static/chunks/593.a7bce429730ed526.js";
	if (chunkId === 4395) return "static/chunks/4395.f4b807778ec9f615.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"3605":"bb50d3d7","5236":"e6d851bd","8955":"435d9882","9774":"framework"}[chunkId] || chunkId) + "-" + {"966":"68a366943f958588","1468":"d2e1d8de7bcf697b","3605":"3559e71aa28991a3","4927":"e11cdeffbcb53175","5236":"40adfe6da6557579","8955":"e434844dc592a8f0","9678":"04634c2ec926a76b","9774":"bea1b471ab16001f"}[chunkId] + ".js";
};